import React, { Dispatch, SetStateAction, useState } from "react";
import { GoArrowRight } from "react-icons/go";
// @ts-ignore
import visa from "src/assets/images/visa.png";
import { useAtom } from "jotai";
import SignatureCanvas from "react-signature-canvas";

// @ts-ignore
import privacy from "src/assets/legal/Privacy_Policy.pdf";
// @ts-ignore
import terms from "src/assets/legal/TERMINOS_CONDICIONES.pdf";
// @ts-ignore
import dpa from "src/assets/legal/DPA.pdf";
// @ts-ignore
import contract from "src/assets/legal/sub.pdf";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { itemsAtom } from "src/atoms/constantsCheckout";
import { BASE_URL } from "src/config";

interface Props {
    step: number;
    setStep: Dispatch<SetStateAction<number>>;
}
const PaymentMethodStep = ({ step, setStep }: Props) => {
    const [selectedMethod, setSelectedMethod] = useState("");
    const [items, setItems] = useAtom(itemsAtom);
    const [showAnimation, setShowAnimation] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [isContractSigned, setIsContractSigned] = useState(false);
    const { t } = useTranslation();
    const paymentMethods = [
        { id: "credit-card", label: t("creditCardLabel") },
        { id: "bank-transfer", label: t("bankTransferLabel") },
    ];
    const handleConfirmPayment = async () => {
        setShowAnimation(true);

        try {
            const formData = new FormData();
            const { clubDetails, deliveryBillingDetails } = items;

            // Agregar datos de billing y club al FormData
            Object.entries(deliveryBillingDetails).forEach(([key, value]: any) => {
                formData.append(key, value);
            });
            formData.append("club_name", clubDetails.clubName!);
            // formData.append("division_id", clubDetails.clubDivision!);
            // formData.append("category_id", clubDetails.clubCategory!);
            formData.append("country_code", clubDetails.clubCountry!);
            formData.append("_method", "POST");

            const response = await fetch(`${BASE_URL}sales`, {
                method: "POST",
                body: formData,
            });

            const data = await response.json();

            if (data.status === "ok" && data.clubAddedResult === 1) {
                toast.success(`${t("paymentSuccess")}`);
                setStep(step + 1); // Avanzar al siguiente paso solo si es necesario
            } else if (data.status === "error") {
                toast.error(data.result?.error_msg || "An error occurred.");
            } else {
                toast.error(`${t("unexpectedError")}`);
            }
        } catch (err) {
            console.error(err);
            toast.error(`${t("paymentProcessError")}`);
        } finally {
            setShowAnimation(false);
        }
    };

    const openModal = (content: any) => {
        setModalContent(content);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalContent("");
    };

    const handleSignContract = () => {
        // Marca el contrato como firmado
        setIsContractSigned(true);
        closeModal();
    };

    return (
        <div className="h-full wiz-custom-scroll-bar p-14 lg:w-3/4">
            <div className="max-w-6xl mx-auto  px-6 py-8">
                {showAnimation ? (
                    <div className="flex justify-center items-center h-96">
                        {/* <Player
              autoplay
              loop={false}
              src={animationpay}
              className="w-64 h-64"
            /> */}
                    </div>
                ) : (
                    <>
                        <div className="mb-8">
                            <h2 className="text-3xl font-bold text-gray-900 mb-3">
                                {t("paymentMethodTitle")}
                            </h2>
                            <p className="text-lg text-gray-600 leading-relaxed">
                                {t("paymentMethodSubtitle")}
                            </p>
                        </div>

                        <div className="space-y-4 mb-8">
                            {paymentMethods.map(({ id, label }) => (
                                <label
                                    key={id}
                                    className={`flex items-center border rounded-lg px-4 py-3 cursor-pointer transition hover:border-blue-500 ${selectedMethod === id
                                        ? "border-blue-600 bg-blue-50"
                                        : "border-gray-300"
                                        }`}
                                >
                                    <input
                                        type="radio"
                                        name="payment-method"
                                        className="hidden"
                                        onChange={() => setSelectedMethod(id)}
                                        checked={selectedMethod === id}
                                    />
                                    <div
                                        className={`w-5 h-5 border-2 rounded-full flex items-center justify-center mr-3 ${selectedMethod === id
                                            ? "border-blue-600 bg-blue-600"
                                            : "border-gray-400"
                                            }`}
                                    >
                                        {selectedMethod === id && (
                                            <div className="w-2.5 h-2.5 rounded-full bg-white" />
                                        )}
                                    </div>
                                    <span className="text-gray-800 font-medium">{label}</span>
                                </label>
                            ))}
                        </div>

                        {selectedMethod === "credit-card" && (
                            <div className="p-6 border rounded-lg space-y-4 bg-gray-50 mb-8">
                                <div className="flex items-center gap-4">
                                    <h3 className="text-xl font-semibold">
                                        {t("creditCardDetails")}
                                    </h3>
                                    <img src={visa} alt="Visa" className="w-20" />
                                </div>
                                <div className="space-y-4">
                                    <input
                                        className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
                                        placeholder={t("cardholderNamePlaceholder")}
                                    />
                                    <input
                                        className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
                                        placeholder={t("cardNumberPlaceholder")}
                                    />
                                    <div className="flex gap-4">
                                        <input
                                            className="w-1/2 p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
                                            placeholder={t("expiryDatePlaceholder")}
                                        />
                                        <input
                                            className="w-1/2 p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
                                            placeholder="CVC"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {selectedMethod === "bank-transfer" && (
                            <div className="p-6 border rounded-lg bg-gray-50 space-y-2 text-sm text-gray-700 mb-8">
                                <p>{t("bankTransferInfo1")}</p>
                                <p>{t("bankTransferInfo2")}</p>
                            </div>
                        )}

                        <div className="space-y-4 text-sm text-gray-700">
                            <div className="flex gap-3 items-start">
                                <input type="checkbox" className="mt-1 w-5 h-5" />
                                <p>
                                    {t("dpaAgreement")}{" "}
                                    <button
                                        onClick={() => openModal(dpa)}
                                        className="text-blue-600 underline"
                                    >
                                        {t("dpaAgreement_2")}
                                    </button>{" "}
                                    {t("dpaAgreement_3")}
                                </p>
                            </div>

                            <div className="flex gap-3 items-start">
                                <input type="checkbox" className="mt-1 w-5 h-5" />
                                <p>
                                    {t("termsAgreement")}{" "}
                                    <button
                                        onClick={() => openModal(terms)}
                                        className="text-blue-600 underline"
                                    >
                                        {t("termsAgreement_2")}
                                    </button>{" "}
                                    {t("termsAgreement_3")}{" "}
                                    <button
                                        onClick={() => openModal(privacy)}
                                        className="text-blue-600 underline"
                                    >
                                        {t("termsAgreement_4")}
                                    </button>
                                </p>
                            </div>

                            <div className="flex gap-3 items-start">
                                <input
                                    type="checkbox"
                                    className="mt-1 w-5 h-5"
                                    disabled={!isContractSigned}
                                    checked={isContractSigned}
                                />
                                <p>
                                    {t("contractAgreement")}{" "}
                                    <button
                                        onClick={() => openModal(contract)}
                                        className="text-blue-600 underline"
                                    >
                                        {t("contractAgreement_2")}
                                    </button>
                                </p>
                            </div>
                        </div>

                        <div className="flex gap-4 pt-6">
                            <button
                                onClick={() => setStep(step - 1)}
                                className="px-6 py-3 text-sm rounded-full border border-gray-300 hover:bg-gray-100 transition"
                            >
                                {t("goBack")}
                            </button>
                            <button
                                onClick={handleConfirmPayment}
                                className="px-6 py-3 text-sm rounded-full bg-blue-700 text-white flex items-center gap-2 hover:bg-blue-800 transition"
                            >
                                {t("confirmAndPay")}
                                <GoArrowRight className="w-5 h-5" />
                            </button>
                        </div>
                    </>
                )}

                {isModalOpen && (
                    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
                        <div className="bg-white rounded-lg overflow-hidden shadow-xl w-[90%] max-w-4xl relative">
                            <button
                                onClick={closeModal}
                                className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                            >
                                ✖
                            </button>
                            <iframe src={modalContent} className="w-full h-[70vh]" />
                            {modalContent === contract && (
                                <div className="p-6 space-y-4">
                                    <p className="font-medium">{t("customerSignature")}</p>
                                    <SignatureCanvas
                                        penColor="black"
                                        canvasProps={{
                                            width: 500,
                                            height: 100,
                                            className: "border border-gray-400 rounded",
                                        }}
                                    />
                                    <div className="flex justify-end">
                                        <button
                                            onClick={handleSignContract}
                                            className="px-6 py-2 text-sm rounded-full bg-blue-700 text-white hover:bg-blue-800 transition"
                                        >
                                            {t("signButton")}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PaymentMethodStep;
